import { HStack, SimpleGrid, Text } from "@chakra-ui/react";
import { LoanContext } from "providers/loan";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { useContext, useEffect, useState } from "react";
import { formatFieldTypeValue } from "utils/helpers";
import { FieldValueMap } from "utils/types";

function getRowOfCell(cellIndex: number, columns: number) {
  var rowIndex = Math.floor(cellIndex / columns);
  return rowIndex;
}

export function isEvenRow(cellIndex: number, columns: number) {
  const row = getRowOfCell(cellIndex, columns);
  return row === 0 ? true : row % 2 === 0;
}

export function mapLoanValues(values: any[]) {
  return values.reduce((acc: any, obj: any) => {
    if (obj.loan_field) acc[obj.loan_field.id] = obj.value.field;
    else {
      console.warn("Error in loan field", { obj });
    }
    return acc;
  }, {});
}

const FieldsTable = ({
  fields,
  columns = 2,
  providedValues,
}: {
  fields: any;
  columns?: number;
  providedValues?: FieldValueMap;
}) => {
  const { loan } = useContext(LoanContext);

  const [values, setValues] = useState<{
    [key: string]: any;
  }>(providedValues ?? {});

  const { user } = useTenant();

  useEffect(() => {
    if (providedValues) return;
    if (!loan) return;
    setValues(mapLoanValues(loan.values));
  }, [loan, providedValues]);

  return (
    <SimpleGrid columns={columns} spacingX="20px">
      {fields
        .sort((a: any, b: any) => a.order - b.order)
        .map((field: any, index: number) => (
          <HStack
            key={`${field.id}-${index}`}
            w="100%"
            bg={isEvenRow(index, columns) ? "#F9F8F8" : "white"}
            px="12px"
            alignItems="center"
            justifyContent="space-between"
            pl="13px"
            py="15px"
            fontWeight="500"
            fontSize="14px"
            color="black"
            borderRadius="6px"
          >
            {/* FIELD ON LOAN PAGE */}
            <Text>
              {field.label}
              {/* <FieldCalculation field={field}></FieldCalculation> */}
            </Text>
            <Text
              textAlign="right"
              fontWeight="400"
              fontSize="16px"
              lineHeight="28px"
              color="secondary"
            >
              {field.type === "property"
                ? loan?.property?.name
                : formatFieldTypeValue(field.type, values[field.id], user)}
            </Text>
          </HStack>
        ))}
    </SimpleGrid>
  );
};

export default FieldsTable;
